import React, { useCallback, useRef } from 'react';

import { useMatch } from 'react-router-dom';

import { IBaseProps } from '@rbi-ctg/frontend';
import { CustomEventNames, useMParticleContext } from 'state/mParticle';

import StyledLink from './styled-link';

interface INavLinkProps extends IBaseProps {
  to: string;
  hidden?: boolean;
  requiresExactMatch?: boolean;
  onClick?: () => void;
  className?: string;
  navBarText?: string;
  componentKey?: string;
}

export const NavLink = ({
  requiresExactMatch,
  to,
  children,
  'data-testid': dataQaId,
  onClick,
  hidden,
  componentKey,
  className = '',
  navBarText = '',
}: INavLinkProps) => {
  const mParticle = useMParticleContext();
  const ref = useRef<HTMLAnchorElement | null>(null);

  const onClickAndLogToMParticle = useCallback(() => {
    const linkText = ref.current?.innerText;

    if (navBarText !== '') {
      mParticle.logNavBarClickEvent(navBarText, componentKey);
    }
    mParticle.logNavigationClick(CustomEventNames.NAV_CLICK, { linkText, linkTo: to });

    if (onClick) {
      onClick();
    }
  }, [componentKey, navBarText, componentKey, mParticle, onClick, to]);

  const pathToMatch = requiresExactMatch ? to : `${to}/*`;
  const pathMatch = useMatch(pathToMatch);

  const activeClassName = pathMatch ? 'active' : '';

  return (
    <StyledLink
      to={to}
      onClick={onClickAndLogToMParticle}
      className={`${className} ${activeClassName}`}
      data-testid={dataQaId}
      ref={ref}
      tabIndex={hidden ? -1 : undefined}
    >
      {children}
    </StyledLink>
  );
};

export const iconSize = 25;
